import {
  Accessibility,
  BookHeart,
  Clapperboard,
  Compass,
  HeartHandshake,
  HeartPulse,
  Network,
  Sparkles,
  UsersRound,
} from 'lucide-react'

export const siteName = 'The Noa Movement'

export const donationUrl =
  import.meta.env.VITE_DONATION_URL || 'https://donorbox.org/terapias-de-noa'

export const navItems = [
  { label: 'Inicio', href: '/', page: 'home' },
  { label: 'Nuestra historia', href: '/nuestra-historia/', page: 'story' },
  { label: 'Recursos', href: '/recursos/', page: 'resources' },
  { label: 'Ayúdanos', href: '/ayudanos/', page: 'help' },
  { label: 'Contacto', href: '/contacto/', page: 'contact' },
]

export const marqueeItems = [
  'La esperanza es obligatoria',
  'Recursos que orientan',
  'Comunidad que acompaña',
  'Historias que transforman',
]

export const impactItems = [
  {
    icon: HeartPulse,
    title: 'Terapias',
    description:
      'Acceso a tratamientos y profesionales que impulsan el desarrollo de cada niña y niño.',
  },
  {
    icon: Accessibility,
    title: 'Equipo adaptado',
    description:
      'Herramientas pensadas para fortalecer la autonomía, el bienestar y la vida cotidiana.',
  },
  {
    icon: UsersRound,
    title: 'Acompañamiento',
    description:
      'Una red de familias que comparte aprendizajes, escucha sin juicio y avanza en comunidad.',
  },
]

export const resourceItems = [
  {
    icon: HeartPulse,
    title: 'Terapias',
    description:
      'Métodos, enfoques y preguntas útiles para conversar con el equipo terapéutico.',
    tag: 'Movimiento y desarrollo',
  },
  {
    icon: Sparkles,
    title: 'Tratamientos',
    description:
      'Información organizada para entender alternativas y tomar decisiones acompañadas.',
    tag: 'Opciones de atención',
  },
  {
    icon: Clapperboard,
    title: 'Películas y libros',
    description:
      'Historias y lecturas para aprender, conectar y encontrar nuevas perspectivas.',
    tag: 'Biblioteca compartida',
  },
  {
    icon: Network,
    title: 'Directorio',
    description:
      'Profesionales, centros y redes de apoyo reunidos en un punto de partida accesible.',
    tag: 'Comunidad de cuidado',
  },
]

export const storyTimeline = [
  {
    title: 'El día que todo cambió',
    description:
      'En septiembre de 2022, Noa sufrió un accidente en una piscina. La respuesta médica consiguió estabilizarla, pero la familia recibió un diagnóstico de lesión cerebral severa.',
  },
  {
    title: 'Volver a casa',
    description:
      'La rehabilitación convirtió la vida diaria en un nuevo territorio: tratamientos, cuidados, decisiones complejas y la necesidad de aprender con rapidez.',
  },
  {
    title: 'Una red que sostuvo',
    description:
      'Familiares, amistades, especialistas y personas solidarias hicieron posible avanzar más lejos. Esa comunidad reveló el poder de acompañarse.',
  },
  {
    title: 'Transformar lo aprendido',
    description:
      'The Noa Movement nace para acercar información, recursos y esperanza a otras familias que empiezan un camino parecido.',
  },
]

export const routeSteps = [
  {
    title: 'Atiende la urgencia',
    description:
      'Sigue las indicaciones del equipo médico y solicita una explicación clara del estado actual y de las prioridades inmediatas.',
  },
  {
    title: 'Registra la información',
    description:
      'Reúne estudios, diagnósticos, medicamentos, contactos y preguntas en un expediente que puedas compartir con especialistas.',
  },
  {
    title: 'Construye tu equipo',
    description:
      'Identifica profesionales de confianza y pide que coordinen objetivos, riesgos y próximos pasos entre disciplinas.',
  },
  {
    title: 'Prioriza el cuidado diario',
    description:
      'Organiza alimentación, descanso, movilidad, equipo adaptado y una rutina sostenible para la familia cuidadora.',
  },
  {
    title: 'Activa tu red',
    description:
      'Pide ayuda concreta. Traslados, comidas, trámites y escucha emocional también forman parte de la recuperación.',
  },
  {
    title: 'Revisa y ajusta',
    description:
      'Define metas observables con el equipo tratante y reevalúa el plan conforme aparezcan nuevas necesidades o avances.',
  },
]

export const waysToHelp = [
  {
    icon: HeartHandshake,
    title: 'Dona',
    description:
      'Contribuye a terapias, equipo adaptado y necesidades cotidianas que sostienen la recuperación.',
    href: '/donar-ahora/',
    cta: 'Conoce el impacto',
  },
  {
    icon: UsersRound,
    title: 'Sé un Tío Chido',
    description:
      'Forma parte de la comunidad que decide estar de manera constante, cercana y generosa.',
    href: '/los-tios-chidos/',
    cta: 'Únete a la familia',
  },
  {
    icon: BookHeart,
    title: 'Comparte recursos',
    description:
      'Ayúdanos a encontrar profesionales, herramientas y aprendizajes valiosos para otras familias.',
    href: '/contacto/',
    cta: 'Envíanos información',
  },
  {
    icon: Compass,
    title: 'Difunde',
    description:
      'Lleva el movimiento a tu comunidad y permite que más familias encuentren acompañamiento a tiempo.',
    href: '/contacto/',
    cta: 'Hagamos equipo',
  },
]
